import { RegionType, } from '@wix/shoutout-email-model-v3';
export function shouldShowAd(showAd, regions, _experiments) {
    var _a;
    if (showAd === true) {
        return true;
    }
    else {
        const footerRegion = regions === null || regions === void 0 ? void 0 : regions.find((r) => r.type === RegionType.Footer);
        if (footerRegion) {
            return (_a = footerRegion.data.enabledWixBranding) !== null && _a !== void 0 ? _a : false;
        }
        return false;
    }
}
//# sourceMappingURL=show-ad.js.map